var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row white-background" }, [
    _c("div", { staticClass: "col-lg-1 col-1" }),
    _c("div", { staticClass: "col-lg-10 col-10" }, [
      _c(
        "div",
        {
          staticClass: "step mt-5 mb-5 white-background",
          attrs: { id: "thank-you" }
        },
        [
          _c("h1", [_vm._v(_vm._s(_vm.trans("thankyou_title")))]),
          _c("p", { staticClass: "mt-4 ml-2 bodytext" }, [
            _vm._v(_vm._s(_vm.trans("thankyou_text")))
          ]),
          _c(
            "button",
            {
              staticClass: "button type-2 ml-2 mt-4",
              on: {
                click: function($event) {
                  return _vm.refresh()
                }
              }
            },
            [_vm._v(_vm._s(_vm.trans("button_another_calc")))]
          )
        ]
      )
    ]),
    _c("div", { staticClass: "col-lg-1 col-1" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }